import { useIsMobileDevice } from "@l2r-front/l2r-ui"

import { ChangePasswordFormPost } from "../../forms/ChangePasswordForm"

import * as Styled from "./AccountSettingsPasswordPage.styled"

export const AccountSettingsPasswordPage = (props) => {
    const {
        onSuccess,
    } = props

    const isMobile = useIsMobileDevice()

    return (
        <Styled.Content isMobile={isMobile}>
            <ChangePasswordFormPost onSuccess={onSuccess} />
        </Styled.Content>
    )
}